import mixins from 'vue-typed-mixins';

import StudyMixin from '@/user/mixins/StudyMixin';



export default mixins(StudyMixin).extend({

  name: 'RestTime',

  computed: {
    restTimeString(): string {
      if (this.questionRestMs <= 0) return '00:00';
      const questionRestSec = Math.ceil(this.questionRestMs / 1000);
      const min = Math.floor(questionRestSec / 60);
      const sec = questionRestSec % 60;
      const len = String(min).length > 2 ? String(min).length * -1 : -2;
      return `${('00' + min).slice(len)}:${('00' + sec).slice(-2)}`;
    }
  }



});
